import { render, staticRenderFns } from "./SuggestedActions.vue?vue&type=template&id=5cef47c6&"
import script from "./SuggestedActions.vue?vue&type=script&lang=js&"
export * from "./SuggestedActions.vue?vue&type=script&lang=js&"
import style0 from "./SuggestedActions.vue?vue&type=style&index=0&id=5cef47c6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QDialog,QCard,QCardSection,QCardActions,QBtn,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QDialog,QCard,QCardSection,QCardActions,QBtn})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
